import React from 'react';
import assign from 'lodash/assign';
import { connect } from 'react-redux';
import promise from 'promise';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';

import {
    AdornedInput,
    Adornment,
    Button,
    Checkbox,
    FormField,
    FormHelp,
    IconChevronDown,
    IconChevronUp,
    IconPlus,
    Input,
    Label,
    Select,
    Switch,
    Text,
    TextButton,
} from '@zillow/constellation';

import {
    Col,
    ContentBox,
    Row,
    Center,
} from '@zillow/zrs-comet';

// constants
import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';
import NotificationConstants from 'app/shared/constants/NotificationConstants';
import KeyCodeConstants from 'app/shared/constants/KeyCodeConstants';

import AmenitiesTags from 'app/shared/components/postingPath/AmenitiesTags';
import DropzoneWrapper from 'app/shared/components/postingPath/DropzoneWrapper';
import UnitsMF from 'app/shared/components/postingPath/UnitsMF';
import InvalidFiletypeText from 'app/shared/components/postingPath/InvalidFiletypeText';
import PhotoDisplay from 'app/shared/components/postingPath/PhotoDisplay';
import TourCardEditable from 'app/shared/components/postingPath/TourCardEditable';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import photoUtils from 'app/shared/utils/photoUtils';
import postingUtils from 'app/shared/utils/postingUtils';
import stringHelper from 'app/shared/utils/stringHelper';

import PostingActions from 'app/shared/actions/PostingActions';

// data model
import Photo from 'app/shared/model/Photo';
import Tour from 'app/shared/model/Tour';

// service
import appLogger from 'app/shared/loggers/appLogger';

// Selectors
import { UserSelectors } from 'app/shared/selectors';

// StyledComponents
import {
    StyledAddressInfoText,
    StyledDeleteCol,
    StyledDisplayLayoutDiv,
    StyledDropdownSpacer,
    StyledDropzoneContainerDiv,
    StyledImageCoverDiv,
    StyledImageSpacer,
    StyledFloorplansBarSpacer,
    StyledFormHelp,
    StyledLabel,
    StyledLabelTitle,
    StyledLayoutContainerSpacer,
    StyledMediaCol,
    StyledRemoveLayoutLink,
    StyledToggleViewLink,
    StyledUploadLayoutContainerDiv,
} from './StyledComponents';

import {
    StyledAnchor,
    StyledHR,
} from '../UtilsStyledComponents';

const EMPTY_ARRAY = [];
const UNAVAILABLE_FLOORPLAN_TEXT = 'Unavailable';
const FLOORPLAN_ERROR_PRICING = 'Please contact rentalpartners@zillowgroup.com in order to remove pricing.';

class FloorplansMF extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            amenityInSelectUnits: false,
            isRotatingPhoto: false,
            lowPricePrevious: '',
            highPricePrevious: '',
            isListingPhotoProcessing: this.props.isListingPhotoProcessing || false,
            layoutErrors: {},
            layoutErrorsMsg: {},
            floorplanPhotoErrors: {},
            floorplanPhotoErrorsMsg: {},
            floorplansToggleState: this.createFloorplansToggleState(this.props.formData.floorplans.length),
            uploadingLayout: false,
            uploadingPhotos: false,
            dropzoneUploadingPhotosText: '',
            showInvalidFiletypeTextLayout: false,
            showInvalidFiletypeTextPhoto: false,
            formData: this.props.formData,
        };

        this.addAmenity = this.addAmenity.bind(this);
        this.addFloorplan = this.addFloorplan.bind(this);
        this.allFloorplansExpanded = this.allFloorplansExpanded.bind(this);
        this.generateFloorplanTitle = this.generateFloorplanTitle.bind(this);
        this.makeMain = this.makeMain.bind(this);
        this.onDropRejected = this.onDropRejected.bind(this);
        this.handleRemoveUnit = this.handleRemoveUnit.bind(this);
        this.handleUpdateUnit = this.handleUpdateUnit.bind(this);
        this.handleSaveUnitPrice = this.handleSaveUnitPrice.bind(this);
        this.handleSaveUnitSqFt = this.handleSaveUnitSqFt.bind(this);
        this.removeFloorplan = this.removeFloorplan.bind(this);
        this.removeFloorplanAmenity = this.removeFloorplanAmenity.bind(this);
        this.removePhoto = this.removePhoto.bind(this);
        this.renderFloorplan = this.renderFloorplan.bind(this);
        this.rotatePhoto = this.rotatePhoto.bind(this);
        this.saveCaption = this.saveCaption.bind(this);
        this.updateCaption = this.updateCaption.bind(this);
        this.savePrice = this.savePrice.bind(this);
        this.showAmenities = this.showAmenities.bind(this);
        this.toggleAllFloorplans = this.toggleAllFloorplans.bind(this);
        this.toggleFloorplan = this.toggleFloorplan.bind(this);
        this.updateActive = this.updateActive.bind(this);
        this.updateFloorplan = this.updateFloorplan.bind(this);
        this.updateFloorplanPhotos = this.updateFloorplanPhotos.bind(this);
        this.updateLayoutPhotos = this.updateLayoutPhotos.bind(this);
        this.uploadPhoto = this.uploadPhoto.bind(this);
        this.updatePrice = this.updatePrice.bind(this);
        this.updateSelectUnits = this.updateSelectUnits.bind(this);
        this.updateSqFt = this.updateSqFt.bind(this);
        this.validateListingVisibility = this.validateListingVisibility.bind(this);
        this.updateFloorPlanErrorObject = this.updateFloorPlanErrorObject.bind(this);
        this.clearAmenitiesErrorObj = this.clearAmenitiesErrorObj.bind(this);
    }

    createFloorplansToggleState(numFloorplans) {
        const obj = {};

        for (let i = 0; i < numFloorplans; i++) {
            // On page load:
            //  If multiple floorplans, hide all
            //  If just 1 floorplan, show expanded view
            obj[i] = numFloorplans === 1;
        }

        return obj;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isListingPhotoProcessing !== this.state.isListingPhotoProcessing) {
            this.setState({ isListingPhotoProcessing: nextProps.isListingPhotoProcessing });
        }
        if (nextProps.formData !== this.state.formData) {
            this.setState({ formData: nextProps.formData });
        }
    }

    addFloorplan() {
        const { formData } = this.state;
        const {
            dispatch,
            errorObj,
            propertyId,
            updateErrorObj,
            updateFormData,
            updateStatusMessage,
            validateFloorplans,
        } = this.props;
        const canAddFloorplan = validateFloorplans();
        if (!canAddFloorplan) {
            return;
        }
        const emptyFloorplan = {
            floorPlanId: '',
            active: false,
            name: '',
            price: '',
            lowPrice: '',
            highPrice: '',
            beds: '',
            baths: '',
            sqft: '',
            layoutPhoto: {},
            floorPlanPhotos: [],
            unitAmenities: [],
            units: [],
            tour: new Tour(),
        };
        const floorplanErrorObjBlank = {
            active: null,
            beds: null,
            baths: null,
            price: null,
            lowPrice: null,
            highPrice: null,
            sqft: null,
            units: [],
            photoCaption: null,
            amenities: null,
        };
        const newFloorplans = [...formData.floorplans];
        newFloorplans.push(emptyFloorplan);
        updateFormData({
            floorplans: newFloorplans,
        });

        const floorplanIndex = newFloorplans.length - 1;

        dispatch(PostingActions.property.createNewFloorplan(propertyId))
            .then((result) => {
                newFloorplans[floorplanIndex].floorPlanId = result.floorPlanId;
                updateFormData({
                    floorplans: newFloorplans,
                });

                // Add corresponding floorplan into errorsObj;
                const updatedErrorObj = { ...errorObj };
                updatedErrorObj.floorplans.push({ ...floorplanErrorObjBlank });
                updateErrorObj({ errorObj: updatedErrorObj });
                dispatch(analyticsUtils.track.GAEventV2(
                    AnalyticsConstants.GA_EVENTS.ADD_FLOORPLAN,
                    { label: formData.aliasEncoded }
                ));
            })
            .catch(() => {
                updateStatusMessage('Please fix the inputs highlighted in red.', NotificationConstants.ERROR);
            });
    }

    addAmenity(floorPlanIndex, amenity) {
        let unitAmenities = [];
        const updateFloorPlans = this.props.formData.floorplans;
        const floorPlanId = updateFloorPlans[floorPlanIndex].floorPlanId;
        this.props.updateStatusMessage('Saving...');

        if (updateFloorPlans[floorPlanIndex].unitAmenities.length > 0) {
            unitAmenities = [].concat(updateFloorPlans[floorPlanIndex].unitAmenities);
        }

        unitAmenities.push({
            id: '',
            amenity,
            availableInSelectUnits: this.state.amenityInSelectUnits,
        });
        const lastAddedAmenity = unitAmenities.length - 1;

        return this.props
            .dispatch(
                PostingActions.floorplan.amenity.create({
                    floorPlanId,
                    amenityText: amenity,
                    availableInSelectUnits: this.state.amenityInSelectUnits,
                })
            )
            .then((result) => {
                this.props.updateStatusMessage('All data saved!', NotificationConstants.SUCCESS);
                this.updateFloorPlanErrorObject(floorPlanIndex, 'amenities', null);
                this.setState({ amenityInSelectUnits: false });
                updateFloorPlans[floorPlanIndex].unitAmenities = unitAmenities;
                updateFloorPlans[floorPlanIndex].unitAmenities[lastAddedAmenity].id = result.response.amenityId;
                this.props.updateFormData({
                    floorplans: updateFloorPlans,
                });
            })
            .catch((errorRMWModel) => {
                this.props.updateStatusMessage(
                    'Please fix the inputs highlighted in red.',
                    NotificationConstants.ERROR
                );
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'FloorplansMf.addAmenity',
                });
                this.updateFloorPlanErrorObject(floorPlanIndex, 'amenities', errorRMWModel.message);
                return promise.reject(errorRMWModel.message);
            });
    }

    removeFloorplanAmenity(floorplanIndex, amenityIndex, amenityId) {
        const {
            dispatch,
            formData: { floorplans },
            updateFormData,
            updateStatusMessage,
        } = this.props;
        const updateObject = {};
        const floorplansCopy = cloneDeep(floorplans);
        floorplansCopy[floorplanIndex].unitAmenities.splice(amenityIndex, 1);

        updateStatusMessage('Saving...');
        dispatch(PostingActions.floorplan.amenity.delete(amenityId))
            .then((response) => {
                if (response.success) {
                    updateStatusMessage('All data saved!', NotificationConstants.SUCCESS);
                    updateObject.floorplans = floorplansCopy;
                    updateFormData(updateObject);
                } else {
                    updateStatusMessage(
                        'There was an error deleting your amenity. Please try again.',
                        NotificationConstants.ERROR
                    );
                }
            });
    }

    showAmenities(floorPlanIndex) {
        const updateFloorPlans = this.props.formData.floorplans;
        const unitAmenities = updateFloorPlans[floorPlanIndex].unitAmenities;

        return unitAmenities;
    }

    validateFloorplanPrices() {
        let atLeastOneValidPrice = false;
        const floorplans = this.props.formData.floorplans.slice();
        for (let i = 0; i < floorplans.length; i++) {
            const floorplan = floorplans[i];
            if (!isEmpty(floorplan.lowPrice) || !isEmpty(floorplan.highPrice)) {
                atLeastOneValidPrice = true;
                break;
            }
        }

        return atLeastOneValidPrice;
    }

    handlePriceFocus(priceType, price) {
        this.setState({ [`${priceType}Previous`]: price });
        this.props.updateOnFocus(priceType, price);
    }

    // Don't delete a floorplan / unit or toggle off availability of a floorplan / unit if it's the only visible.
    validateListingVisibility() {
        return this.props.getActiveFloorplanOrUnitCount() > 1;
    }

    handleSaveUnitPrice(newValue, floorplanIndex, unitIndex) {
        if (newValue.indexOf('.') > -1) {
            const floorplanErrors = cloneDeep(this.props.errorObj.floorplans);
            if (floorplanErrors[floorplanIndex].units[unitIndex]) {
                floorplanErrors[floorplanIndex].units[unitIndex].price = 'Please enter only whole numbers.';
                this.props.updateErrorObj({ floorPlans: floorplanErrors });
            }
            return;
        }
        this.props.saveFloorplanData('price', newValue, floorplanIndex, unitIndex);
    }

    handleSaveUnitSqFt(newValue, floorplanIndex, unitIndex) {
        const sqft = postingUtils.validateSqFt(newValue);
        if (sqft === null) {
            const floorplanErrors = cloneDeep(this.props.errorObj.floorplans);
            floorplanErrors[floorplanIndex].units[unitIndex].sqft = 'Please enter only whole numbers.';
            this.props.updateErrorObj({ floorPlans: floorplanErrors });
            return;
        }
        this.props.saveFloorplanData('sqft', newValue, floorplanIndex, unitIndex);
    }

    savePrice(priceType, newValue, index) {
        const { isPostingPathAdmin, formData } = this.props;
        const previousPrice = `${priceType}Previous`;
        const oldValue = this.state[previousPrice];
        const isActive = formData.active;
        const isClearingPrice = isEmpty(newValue) && !isEmpty(oldValue);
        let canSave = true;
        if (!isPostingPathAdmin && isActive && isClearingPrice) {
            canSave = this.validateFloorplanPrices();
        }

        if (canSave) {
            if (newValue.indexOf('.') > -1) {
                const floorplanErrors = assign({}, this.props.errorObj.floorplans);
                floorplanErrors[index][priceType] = 'Please enter only whole numbers.';
                this.props.updateErrorObj({ floorPlans: floorplanErrors });
                return;
            }

            this.props.saveFloorplanData(priceType, newValue, index);
        } else {
            this.updatePrice(priceType, oldValue, index);
            const floorplanErrors = assign({}, this.props.errorObj.floorplans);
            floorplanErrors[index][priceType] = FLOORPLAN_ERROR_PRICING;
            this.props.updateErrorObj({ floorPlans: floorplanErrors });
        }
    }

    updatePrice(priceType, value, index) {
        this.updateFloorplan(priceType, value, index);
    }

    removeFloorplan(e, floorplanIndex) {
        e.preventDefault();
        const floorplan = this.props.formData.floorplans[floorplanIndex];
        const globalActiveCount = this.props.getActiveFloorplanOrUnitCount();
        let isLastActiveFloorplan = true;
        if (floorplan.units.length > 0) {
            const activeUnitsCount = floorplan.units.reduce((acc, unit) => acc + (unit.active ? 1 : 0), 0);
            isLastActiveFloorplan = activeUnitsCount > 0 && globalActiveCount === activeUnitsCount;
        } else {
            isLastActiveFloorplan = floorplan.active && globalActiveCount === 1;
        }
        if (isLastActiveFloorplan) {
            this.props.updateStatusMessage('Cannot delete last available floor plan', NotificationConstants.ERROR);
            return;
        }

        const newFloorplans = [].concat(this.props.formData.floorplans);
        const floorPlanId = newFloorplans[floorplanIndex].floorPlanId;
        newFloorplans.splice(floorplanIndex, 1);

        this.props.updateFormData({
            floorplans: newFloorplans,
        });

        this.props.dispatch(PostingActions.property.removeFloorplan(floorPlanId))
            .then((result) => {
                const { floorplansToggleState: floorplansToggle } = this.state;
                const updateErrorObj = [].concat(this.props.errorObj.floorplans);
                const floorplansToggleState = assign({}, floorplansToggle);

                // Remove corresponding floorplan from errors object.
                updateErrorObj.splice(floorplanIndex, 1);
                this.props.updateErrorObj({ floorplans: updateErrorObj });

                // Update Floorplans toggle state
                floorplansToggleState[floorplanIndex] = false;
                this.setState({ floorplansToggleState });

                return result;
            })
            .catch(() => {
                const clientErrMsg = 'An error has occurred removing your floor plan.';
                this.props.updateStatusMessage(clientErrMsg, NotificationConstants.ERROR);
            });
    }

    handleRemoveUnit(floorplanIndex, unitIndex) {
        const canDeleteUnit = !this.props.formData.floorplans[floorplanIndex].units[unitIndex].active
            || this.validateListingVisibility();
        if (!canDeleteUnit) {
            this.props.updateStatusMessage('Cannot delete last available unit', NotificationConstants.ERROR);
            return;
        }

        const newFloorplans = cloneDeep(this.props.formData.floorplans);
        const unit = newFloorplans[floorplanIndex].units[unitIndex];
        if (!unit) {
            console.warn('Cannot delete unexisting unit');
            return;
        }
        newFloorplans[floorplanIndex].units.splice(unitIndex, 1);

        this.props.updateFormData({
            floorplans: newFloorplans,
        });

        const formData = { ...this.state };
        const newFormData = formData;
        newFormData.floorplans = newFloorplans;
        this.setState({ formData: newFormData });

        this.props.dispatch(PostingActions.property.removeFloorplan(unit.unitId))
            .then(() => {
                const updateErrorObj = cloneDeep(this.props.errorObj.floorplans);
                updateErrorObj[floorplanIndex].units.splice(unitIndex, 1);
                this.props.updateErrorObj({ floorplans: updateErrorObj });
            })
            .catch(() => {
                const clientErrMsg = 'An error has occurred removing your unit.';
                this.props.updateStatusMessage(clientErrMsg, NotificationConstants.ERROR);
            });
    }

    onDropRejected(type, index) {
        // TODO:  get failed event or access to rejected files from MUI in order to use maxSize prop in Dropzone Container
        const layoutErrors = assign({}, this.state.layoutErrors);
        const floorplanPhotoErrors = assign({}, this.state.floorplanPhotoErrors);

        if (type === 'layout') {
            if (!layoutErrors[index]) {
                layoutErrors[index] = true;
            } else {
                layoutErrors[index] = !layoutErrors[index];
            }
            this.setState({ layoutErrors });
        } else if (type === 'floorplan') {
            if (!floorplanPhotoErrors[index]) {
                floorplanPhotoErrors[index] = true;
            } else {
                floorplanPhotoErrors[index] = !floorplanPhotoErrors[index];
            }
            this.setState({ floorplanPhotoErrors });
        }
    }

    updateSelectUnits() {
        const { amenityInSelectUnits } = this.state;
        this.setState({ amenityInSelectUnits: !amenityInSelectUnits });
    }

    handleInvalidExtension() {
        this.setState({
            uploadingPhotos: false,
            showInvalidFiletypeTextPhoto: true,
        });

        this.props.updateStatusMessage(
            ErrorMessageConstants.DEFAULT_PHOTO_ERROR,
            NotificationConstants.ERROR
        );
    }

    updateFloorplanPhotos(files, floorplanIndex) {
        const { user } = this.props;
        const { floorplanPhotoErrors, floorplanPhotoErrorsMsg } = this.state;
        const promiseArr = [];
        const filesCount = files.length;
        const photoText = stringHelper.pluralize(filesCount, 'photo', 'photos');

        let uploadStatusText = `Uploading ${photoText}...`;
        let counter = 1;
        let hasInvalidExtension = false;

        let newFloorplanPhotoErrors = assign({}, floorplanPhotoErrors);
        newFloorplanPhotoErrors[floorplanIndex] = null;

        let newFloorplanPhotoErrorsMsg = assign({}, floorplanPhotoErrorsMsg);
        newFloorplanPhotoErrorsMsg[floorplanIndex] = '';

        this.setState({
            floorplanPhotoErrors: newFloorplanPhotoErrors,
            floorplanPhotoErrorsMsg: newFloorplanPhotoErrorsMsg,
            uploadingPhotos: true,
            showInvalidFiletypeTextPhoto: false,
            dropzoneUploadingPhotosText: uploadStatusText,
        });

        this.props.updateListingPhotoProcessingStatus(true);
        this.props.updateStatusMessage(uploadStatusText);

        files.forEach((file, index) => {
            const isValidFiletype = photoUtils.hasValidExtension(file);

            if (isValidFiletype) {
                const updatedFloorPlans = [].concat(this.props.formData.floorplans);
                const floorPlanId = updatedFloorPlans[floorplanIndex].floorPlanId;

                const p = new Promise((resolve) => {
                    this.uploadPhoto(file, 'floorplan', floorPlanId)
                        .then((result) => {
                            file.id = String(result.id);
                            file.url = String(result.url);

                            updatedFloorPlans[floorplanIndex].floorPlanPhotos.push(file);
                            const recentPhotoIndex = updatedFloorPlans[floorplanIndex].floorPlanPhotos.length - 1;

                            updatedFloorPlans[floorplanIndex].floorPlanPhotos[recentPhotoIndex] = file;
                            newFloorplanPhotoErrors = assign({}, this.state.floorplanPhotoErrors);
                            newFloorplanPhotoErrors[floorplanIndex] = false;

                            newFloorplanPhotoErrorsMsg = assign({}, this.state.floorplanPhotoErrorsMsg);
                            newFloorplanPhotoErrorsMsg[floorplanIndex] = '';

                            if (index >= files.length - 1) {
                                this.setState({
                                    floorplanPhotoErrors: newFloorplanPhotoErrors,
                                    floorplanPhotoErrorsMsg: newFloorplanPhotoErrorsMsg,
                                });
                            }

                            uploadStatusText = `Uploaded ${counter} out of ${photoText}!`;
                            this.props.updateStatusMessage(uploadStatusText);
                            this.setState({
                                dropzoneUploadingPhotosText: uploadStatusText,
                            });
                            counter += 1;
                            // resolve photo
                            resolve(new Photo(result));
                        })
                        .catch((clientErrMsg) => {
                            newFloorplanPhotoErrors = assign({}, this.state.floorplanPhotoErrors);
                            newFloorplanPhotoErrors[floorplanIndex] = true;

                            newFloorplanPhotoErrorsMsg = assign({}, this.state.floorplanPhotoErrorsMsg);
                            newFloorplanPhotoErrorsMsg[floorplanIndex] = clientErrMsg;

                            this.setState({
                                floorplanPhotoErrors: newFloorplanPhotoErrors,
                                floorplanPhotoErrorsMsg: newFloorplanPhotoErrorsMsg,
                                uploadingPhotos: false,
                            });

                            this.props.updateListingPhotoProcessingStatus(false);

                            // resolve with error
                            resolve({ error: true });

                            // dispatch
                            appLogger.logError({
                                message: clientErrMsg,
                                context: 'FloorplansMF.uploadFloorplanPhotos',
                                user,
                            });
                        });
                });

                promiseArr.push(p);
            } else {
                hasInvalidExtension = true;
            }
        });

        if (promiseArr.length > 0) {
            // handle promises
            promise
                .all(promiseArr)
                .then(() => {
                    this.setState({ uploadingPhotos: false });
                    this.props.updateStatusMessage('Upload complete!', NotificationConstants.SUCCESS);
                    this.props.updateListingPhotoProcessingStatus(false);

                    if (hasInvalidExtension) {
                        this.handleInvalidExtension();
                    }
                })
                .catch(() => {
                    this.setState({ uploadingPhotos: false });
                    this.props.updateListingPhotoProcessingStatus(false);
                    this.props.updateStatusMessage(
                        ErrorMessageConstants.DEFAULT_PHOTO_ERROR,
                        NotificationConstants.ERROR
                    );

                    appLogger.logError({
                        message: ErrorMessageConstants.DEFAULT_PHOTO_ERROR,
                        context: 'updateFloorplanPhotos',
                        user,
                    });
                });
        } else {
            this.setState({
                uploadingPhotos: false,
            });

            if (hasInvalidExtension) {
                this.handleInvalidExtension();
            }
        }
    }

    updateLayoutPhotos(file, floorplanIndex) {
        const { layoutErrors, layoutErrorsMsg } = this.state;
        let newLayoutErrors = assign({}, layoutErrors);
        newLayoutErrors[floorplanIndex] = null;

        let newLayoutErrorsMsg = assign({}, layoutErrorsMsg);
        newLayoutErrorsMsg[floorplanIndex] = '';

        if (Array.isArray(file)) {
            file = file[0];
        }
        this.props.updateStatusMessage('Saving...');
        this.setState({
            layoutErrors: newLayoutErrors,
            uploadingLayout: true,
            showInvalidFiletypeTextLayout: false,
        });

        const isValidFiletype = photoUtils.hasValidExtension(file);

        if (isValidFiletype) {
            const newFloorplans = [].concat(this.props.formData.floorplans);
            newFloorplans[floorplanIndex].layoutPhoto = file;
            const floorPlanId = newFloorplans[floorplanIndex].floorPlanId;

            this.props.updateFormData({
                floorplans: newFloorplans,
            });

            this.uploadPhoto(file, 'layout', floorPlanId)
                .then(() => {
                    this.props.updateStatusMessage('All data saved!', NotificationConstants.SUCCESS);
                    newLayoutErrors = assign({}, this.state.layoutErrors);
                    newLayoutErrors[floorplanIndex] = null;

                    newLayoutErrorsMsg = assign({}, this.state.layoutErrorsMsg);
                    newLayoutErrorsMsg[floorplanIndex] = '';

                    this.setState({
                        layoutErrors: newLayoutErrors,
                        layoutErrorsMsg: newLayoutErrorsMsg,
                        uploadingLayout: false,
                    });
                })
                .catch((clientErrMsg) => {
                    this.props.updateStatusMessage(
                        ErrorMessageConstants.DEFAULT_PHOTO_ERROR,
                        NotificationConstants.ERROR
                    );

                    newLayoutErrors = assign({}, this.state.layoutErrors);
                    newLayoutErrors[floorplanIndex] = true;

                    newLayoutErrorsMsg = assign({}, this.state.layoutErrorsMsg);
                    newLayoutErrorsMsg[floorplanIndex] = clientErrMsg;

                    this.setState({
                        layoutErrors: newLayoutErrors,
                        layoutErrorsMsg: newLayoutErrorsMsg,
                        uploadingLayout: false,
                    });

                    // dispatch
                    appLogger.logError({
                        message: clientErrMsg,
                        context: 'FloorplansMF.uploadLayoutPhotos.uploadPhoto',
                    });
                });
        } else {
            this.setState({
                layoutErrors: {},
                uploadingLayout: false,
                showInvalidFiletypeTextLayout: true,
            });

            this.props.updateStatusMessage(
                ErrorMessageConstants.DEFAULT_PHOTO_ERROR,
                NotificationConstants.ERROR
            );
        }
    }

    uploadPhoto(fileOrBlob, photoType, id) {
        const { size } = fileOrBlob;
        const DROPZONE_MAX_FILESIZE = 25000000;

        if (size > DROPZONE_MAX_FILESIZE) {
            const clientErrMsg = 'Sorry. Your file is too large. Maximum size allowed is 25MB';
            this.setState({ uploadingPhotos: false });

            return Promise.reject(clientErrMsg);
        }
        let dataForApi = {};
        const formData = new FormData();
        let uploadPhotoFunc;

        formData.append('sourceFile', fileOrBlob);
        dataForApi = {
            fileOrBlob,
            formData,
        };
        if (photoType === 'floorplan') {
            uploadPhotoFunc = PostingActions.floorplan.photo.upload;
            dataForApi.floorPlanId = id;
        } else if (photoType === 'layout') {
            uploadPhotoFunc = PostingActions.floorplan.layout.upload;
            dataForApi.floorPlanId = id;
        }

        return this.props
            .dispatch(uploadPhotoFunc(dataForApi))
            .then(result => result)
            .catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'FloorplansMF.uploadPhoto',
                });
                return Promise.reject(errorRMWModel.message);
            });
    }

    makeMain(floorPlanIndex, photoIndex) {
        const updateFloorplans = [].concat(this.props.formData.floorplans);
        const photoArray = [].concat(updateFloorplans[floorPlanIndex].floorPlanPhotos);

        // Splice off image off array
        const imageToMove = assign({}, photoArray[photoIndex]);
        photoArray.splice(photoIndex, 1);
        photoArray.unshift(imageToMove);

        updateFloorplans[floorPlanIndex].floorPlanPhotos = photoArray;

        this.props.updateFormData({
            floorplans: updateFloorplans,
        });
    }

    saveCaption(floorPlanIndex, caption, photoIndex) {
        this.props.updateStatusMessage('Saving...');
        const updateFloorplans = [].concat(this.props.formData.floorplans);
        const photoId = updateFloorplans[floorPlanIndex].floorPlanPhotos[photoIndex].id;

        return this.props.dispatch(PostingActions.floorplan.photo.caption(photoId, caption))
            .then((result) => {
                if (result.success) {
                    // only updating the form upon success since update is computationally expensive
                    this.updateCaption(floorPlanIndex, caption, photoIndex);

                    this.props.updateStatusMessage('All data saved!', NotificationConstants.SUCCESS);
                    this.updateFloorPlanErrorObject(floorPlanIndex, 'photoCaption', null);
                } else {
                    appLogger.logError({
                        message: result.error,
                        context: 'FloorplansMf.saveCaption',
                    });
                    this.updateFloorPlanErrorObject(floorPlanIndex, 'photoCaption', result.error.message);
                    this.props.updateStatusMessage(
                        'Please fix the inputs highlighted in red.',
                        NotificationConstants.ERROR
                    );
                }
            });
    }

    updateFloorPlanErrorObject(floorPlanIndex, field, errorMessage) {
        const updatedErrorObj = { ...this.props.errorObj };
        updatedErrorObj.floorplans[floorPlanIndex][field] = errorMessage;
        this.props.updateErrorObj({ errorObj: updatedErrorObj });
    }

    clearAmenitiesErrorObj(floorPlanIndex) {
        this.updateFloorPlanErrorObject(floorPlanIndex, 'amenities', null);
    }

    updateCaption(floorPlanIndex, caption, photoIndex) {
        const updateFloorplans = [].concat(this.props.formData.floorplans);
        updateFloorplans[floorPlanIndex].floorPlanPhotos[photoIndex].caption = caption;

        this.props.updateFormData({
            floorplans: updateFloorplans,
        });
    }

    updateFloorplan(key, value, floorplanIndex) {
        const currentState = this.state.formData;
        const updateFloorplans = [].concat(currentState.floorplans);
        updateFloorplans[floorplanIndex][key] = value;
        currentState.floorplans = updateFloorplans;
        this.setState({ formData: currentState });

        if (this.props.errorObj.floorplans[floorplanIndex][key] && value.length > 0) {
            const newErrorObj = [].concat(this.props.errorObj.floorplans);
            newErrorObj[floorplanIndex][key] = null;
            this.props.updateErrorObj({ floorplans: newErrorObj });
        }
    }

    handleUpdateUnit(key, value, floorplanIndex, unitIndex) {
        const updateFloorplans = cloneDeep(this.props.formData.floorplans);
        if (!updateFloorplans[floorplanIndex].units[unitIndex]) {
            return;
        }
        updateFloorplans[floorplanIndex].units[unitIndex][key] = value;
        this.props.updateFormData({
            floorplans: updateFloorplans,
        });

        const errorUnitObj = this.props.errorObj.floorplans[floorplanIndex].units[unitIndex];
        if (errorUnitObj && errorUnitObj[key] && value.length > 0) {
            const newFloorplanErrorObj = cloneDeep(this.props.errorObj.floorplans);
            if (!newFloorplanErrorObj[floorplanIndex].units[unitIndex]) {
                console.warn('Cannot update unexisting error unit object');
                return;
            }
            newFloorplanErrorObj[floorplanIndex].units[unitIndex][key] = null;
            this.props.updateErrorObj({ floorplans: newFloorplanErrorObj });
        }
    }

    removePhoto(floorPlanIndex, type, photoIndex) {
        if (this.state.isRotatingPhoto) {
            console.warn('[WARNING] photo is currently rotating');
            return;
        }

        const updateFloorPlans = [].concat(this.props.formData.floorplans);
        const floorPlanId = updateFloorPlans[floorPlanIndex].floorPlanId;

        this.props.updateListingPhotoProcessingStatus(true);
        if (type === 'floorplan') {
            const photoIdToDelete = updateFloorPlans[floorPlanIndex].floorPlanPhotos[photoIndex].id;

            this.props.dispatch(PostingActions.floorplan.photo.delete(photoIdToDelete)).then(() => {
                updateFloorPlans[floorPlanIndex].floorPlanPhotos.splice(photoIndex, 1);
                this.props.updateListingPhotoProcessingStatus(false);
            });
        } else if (type === 'layout') {
            this.props.dispatch(PostingActions.floorplan.layout.delete(floorPlanId)).then(() => {
                updateFloorPlans[floorPlanIndex].layoutPhoto = {};
                this.props.updateListingPhotoProcessingStatus(false);
            });
        }

        this.props.updateFormData({ floorplans: updateFloorPlans });
    }

    rotatePhoto(floorPlanIndex, photoIndex) {
        this.setState({ isRotatingPhoto: true });
        this.props.updateErrorObj({ photos: null });
        this.props.updateStatusMessage('Rotating image...');

        const copyFloorPlans = cloneDeep(this.props.formData.floorplans);
        const photoToRotate = copyFloorPlans[floorPlanIndex].floorPlanPhotos[photoIndex];

        this.props.updateListingPhotoProcessingStatus(true);
        this.props.dispatch(
            PostingActions.floorplan.photo.rotate(photoToRotate.id)
        )
            .then((response) => {
                const rotatedPhotoUrl = response.response.url;
                photoToRotate.url = rotatedPhotoUrl;

                this.props.updateFormData({ floorplans: copyFloorPlans });
                this.props.updateStatusMessage('All data saved!', NotificationConstants.SUCCESS);
            })
            .catch((clientErrMsg) => {
                clientErrMsg = 'There was an error rotating your photo.';
                const errorObjMsg = `${clientErrMsg} Please try again.`;

                this.props.updateStatusMessage(clientErrMsg, NotificationConstants.ERROR);
                this.props.updateErrorObj({ photos: errorObjMsg });

                appLogger.logError({
                    message: errorObjMsg,
                    context: 'FloorplansMF.uploadPhoto',
                });
            })
            .finally(() => {
                this.setState({ isRotatingPhoto: false });
                this.props.updateListingPhotoProcessingStatus(false);
            });
    }

    allFloorplansExpanded() {
        return Object.values(this.state.floorplansToggleState).every(item => item);
    }

    toggleFloorplan(index) {
        const { floorplansToggleState: floorplansToggle } = this.state;
        const floorplansToggleState = assign({}, floorplansToggle);

        // If new floorplan
        if (floorplansToggleState[index] === undefined) {
            floorplansToggleState[index] = true;
        } else {
            floorplansToggleState[index] = !floorplansToggleState[index];
        }

        this.setState({ floorplansToggleState });
    }

    toggleAllFloorplans(expand = false) {
        const { floorplansToggleState: floorplansToggle } = this.state;
        const floorplansToggleState = assign({}, floorplansToggle);

        Object.keys(floorplansToggleState).forEach((key) => {
            floorplansToggleState[key] = expand;
        });

        this.setState({ floorplansToggleState });
    }

    updateActive(newActive, floorplanIndex, unitIndex = null) {
        if (newActive === false) {
            const canDeactivate = this.validateListingVisibility();
            if (!canDeactivate) {
                const errorMessage = `Cannot deactivate last available ${unitIndex === null ? 'floor plan' : 'unit'}`;
                this.props.updateStatusMessage(errorMessage, NotificationConstants.ERROR);
                return;
            }
        } else {
            const canActivate = unitIndex === null
                ? this.props.validateFloorplan(floorplanIndex, false)
                : this.props.validateUnit(floorplanIndex, unitIndex);
            if (!canActivate) {
                return;
            }
        }
        if (unitIndex === null) {
            this.updateFloorplan('active', newActive, floorplanIndex);
        } else {
            this.handleUpdateUnit('active', newActive, floorplanIndex, unitIndex);
        }
        this.props.saveFloorplanData('active', newActive, floorplanIndex, unitIndex);
    }

    updateSqFt(value, index) {
        const sqft = postingUtils.validateSqFt(value);
        const floorplanErrors = assign({}, this.props.errorObj.floorplans);

        if (sqft === null) {
            floorplanErrors[index].sqft = 'Please enter only whole numbers.';
        } else {
            floorplanErrors[index].sqft = null;
            this.props.saveFloorplanData('sqft', sqft, index);
        }
        this.props.updateErrorObj({ floorPlans: floorplanErrors });
    }

    formatPrice(lowPrice, highPrice) {
        if (!lowPrice && !highPrice) {
            return '';
        }
        if (lowPrice && highPrice) {
            return `$${lowPrice}-$${highPrice}, `;
        }
        return `$${lowPrice || highPrice}, `;
    }

    /**
     *  Ex) with name: "Rain | $1234, 1 Bed, 1 Bath, 123 Sqft
     *      w/o name : "1 bed, 1 bath"
     *      w/o bed or bath: "- bed, - bath"
     */
    generateFloorplanTitle(floorplan) {
        const {
            baths,
            beds,
            name,
            lowPrice,
            highPrice,
            sqft,
        } = floorplan;

        const displayPrice = this.formatPrice(lowPrice, highPrice);
        const displayBaths = baths || '-';
        const displaySqft = sqft ? `, ${sqft} sqft` : '';
        const displayName = name ? `${name} ` : '';
        const displayBeds = beds || beds === 0 ? beds : '-';

        if (name) {
            return (
                <React.Fragment>
                    {displayName}
                    <StyledAddressInfoText>
                        |
                        {' '}
                        {displayPrice}
                        {displayBeds}
                        {' '}
                        beds,
                        {displayBaths}
                        {' '}
                        baths
                        {displaySqft}
                    </StyledAddressInfoText>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                {displayPrice}
                {displayBeds}
                {' '}
                beds,
                {displayBaths}
                {' '}
                 baths
                {displaySqft}
            </React.Fragment>
        );
    }

    onKeyUp = (event) => {
        if (event.keyCode === KeyCodeConstants.ENTER) {
            event.target.click();
        }
    }

    renderLayout(floorplan, floorPlanIndex) {
        const {
            layoutErrors,
            layoutErrorsMsg,
            uploadingLayout,
            showInvalidFiletypeTextLayout,
        } = this.state;
        const { isInputFormDisabled } = this.props;

        if (!isEmpty(floorplan.layoutPhoto) && layoutErrors[floorPlanIndex] !== true) {
            const photo = floorplan.layoutPhoto;
            return (
                <StyledDisplayLayoutDiv>
                    <div>
                        <Label>Floor plan layout</Label>

                        <StyledRemoveLayoutLink
                            aria-label="Remove layout"
                            tabIndex={0}
                            onClick={() => this.removePhoto(floorPlanIndex, 'layout')}
                            onKeyUp={this.onKeyUp}
                        >
                            Remove layout
                        </StyledRemoveLayoutLink>
                    </div>

                    <div className="uploaded-layout">
                        <img src={photo.url ? photo.url : photo.preview} alt="uploaded-layout" />
                    </div>
                </StyledDisplayLayoutDiv>
            );
        }
        if (uploadingLayout && layoutErrors[floorPlanIndex] !== true) {
            return (
                <StyledDisplayLayoutDiv>
                    <Label>Floor plan layout</Label>
                    <StyledUploadLayoutContainerDiv>
                        <Text>Uploading layout...</Text>
                        <SpinnerContainer size="lg" />
                    </StyledUploadLayoutContainerDiv>
                </StyledDisplayLayoutDiv>
            );
        }
        if (this.props.formData.vaultware) {
            return (
                <StyledDisplayLayoutDiv>
                    <Label>Floor plan layout</Label>
                    <div className="hp-dz disabled">
                        <div className="add-image-icon">
                            <i className="icon-plus" />
                        </div>
                        <Text>Layout / Floor plan</Text>
                    </div>
                </StyledDisplayLayoutDiv>
            );
        }
        if (!isInputFormDisabled) {
            return (
                <StyledDisplayLayoutDiv>
                    <Label>Floor plan layout</Label>
                    <StyledDropzoneContainerDiv>
                        <DropzoneWrapper
                            isUploading={uploadingLayout}
                            isUploadingCaption="Uploading. Please wait. . ."
                            onDrop={files => this.updateLayoutPhotos(files, floorPlanIndex)}
                            onDropRejected={() => this.onDropRejected('layout', floorPlanIndex)}
                        />
                    </StyledDropzoneContainerDiv>
                    {layoutErrors[floorPlanIndex] && (
                        <FormHelp error={true}>{layoutErrorsMsg[floorPlanIndex]}</FormHelp>
                    )}

                    {
                        showInvalidFiletypeTextLayout && <InvalidFiletypeText />
                    }
                </StyledDisplayLayoutDiv>
            );
        }
        return null;
    }

    renderFloorplanPhotos(floorPlanIndex) {
        const {
            floorplanPhotoErrors,
            floorplanPhotoErrorsMsg,
            isListingPhotoProcessing,
            showInvalidFiletypeTextPhoto,
            uploadingPhotos,
            dropzoneUploadingPhotosText,
        } = this.state;

        const { errorObj } = this.props;

        const floorPlanPhotos = this.props.formData.floorplans[floorPlanIndex].floorPlanPhotos;

        if (this.props.formData.vaultware) {
            return (
                <StyledUploadLayoutContainerDiv>
                    <Text>Photos</Text>
                    <IconPlus fontColor="brand" size="lg" />
                </StyledUploadLayoutContainerDiv>
            );
        }

        return (
            <div className="floorplan-photos">
                <Label>Floor Plan Photos (admin only)</Label>

                <div>
                    <StyledDropzoneContainerDiv>
                        <DropzoneWrapper
                            isUploading={uploadingPhotos}
                            isUploadingCaption={dropzoneUploadingPhotosText}
                            multiple={true}
                            onDrop={files => this.updateFloorplanPhotos(files, floorPlanIndex)}
                            onDropRejected={() => this.onDropRejected('floorplan', floorPlanIndex)}
                        />
                    </StyledDropzoneContainerDiv>
                    {floorplanPhotoErrors[floorPlanIndex] && (
                        <FormHelp error={true}>{floorplanPhotoErrorsMsg[floorPlanIndex]}</FormHelp>
                    )}

                    {showInvalidFiletypeTextPhoto && <InvalidFiletypeText />}
                </div>

                {floorPlanPhotos.length > 0 && <Label>Uploaded Floor Plan Photos</Label>}

                {floorPlanPhotos.map((photo, photoIndex) => (
                    <StyledImageSpacer
                        marginX={-2}
                        paddingX={2}
                        key={`photo-${photoIndex}`}
                    >
                        {isListingPhotoProcessing && <StyledImageCoverDiv />}

                        <PhotoDisplay
                            initialValue={photo.caption}
                            onBlur={e => this.saveCaption(floorPlanIndex, e.target.value, photoIndex)}
                            photo={photo}
                            removePhoto={() => this.removePhoto(floorPlanIndex, 'floorplan', photoIndex)}
                            rotatePhoto={() => this.rotatePhoto(floorPlanIndex, photoIndex)}
                        />

                        {errorObj.floorplans[floorPlanIndex].photoCaption && (
                            <FormHelp
                                error={errorObj.floorplans[floorPlanIndex].photoCaption}
                                dangerouslySetInnerHTML={{ __html: errorObj.floorplans[floorPlanIndex].photoCaption }}
                            />
                        )}
                    </StyledImageSpacer>
                ))}
            </div>
        );
    }

    renderFloorplan(floorplan, index) {
        const {
            isPostingPathAdmin,
            errorObj,
            updateErrorObj,
            updateStatusMessage,
            isInputFormDisabled,
            isAddingUnit,
            saveFloorplanData,
            isMobile,
            canEditTourOverwrite,
        } = this.props;

        const { formData } = { ...this.state };

        const floorPlanCount = formData.floorplans.length;
        const floorplanErrorObj = errorObj.floorplans[index] || {};
        const hasErrors = Object.values(floorplanErrorObj).some((item) => {
            if (Array.isArray(item)) {
                return item.some(innerObj => Object.values(innerObj).some(innerItem => innerItem));
            }
            return item;
        });

        const floorPlanErrors = {
            beds: floorplanErrorObj.beds || null,
            baths: floorplanErrorObj.baths || null,
            lowPrice: floorplanErrorObj.lowPrice || null,
            highPrice: floorplanErrorObj.highPrice || null,
            active: floorplanErrorObj.active || null,
            sqft: floorplanErrorObj.sqft || null,
            name: floorplanErrorObj.name || null,
            units: floorplanErrorObj.units || EMPTY_ARRAY,
        };

        const showFloorplanDetails = this.state.floorplansToggleState[index];

        if (showFloorplanDetails === undefined) {
            // Add floorplan index to floorplansToggleState
            this.toggleFloorplan(index);
        }

        const CustomTag = showFloorplanDetails ? ContentBox : 'div';
        const canAddUnits = !isAddingUnit && !hasErrors;
        const hasUnits = floorplan.units.length > 0;

        const showErrorText = hasErrors && !showFloorplanDetails;
        let availableText = '';
        if (!hasErrors && !showFloorplanDetails) {
            availableText = UNAVAILABLE_FLOORPLAN_TEXT;
            if (floorplan.units.length > 0) {
                let availableUnitCount = 0;
                let availableUnitSoonCount = 0;
                const now = new Date().toISOString().substring(0, 10);
                for (let i = 0; i < floorplan.units.length; i++) {
                    const unit = floorplan.units[i];
                    if (unit.dateAvailable && unit.dateAvailable > now) {
                        // eslint-disable-next-line no-plusplus
                        availableUnitSoonCount++;
                    } else if (unit.active) {
                        // eslint-disable-next-line no-plusplus
                        availableUnitCount++;
                    }
                }
                const availableUnitArrayText = [];
                if (availableUnitCount > 0) {
                    const availableUnitText =
                        `${stringHelper.pluralize(availableUnitCount, 'unit', 'units')} available`;
                    availableUnitArrayText.push(availableUnitText);
                }
                if (availableUnitSoonCount > 0) {
                    const availableUnitSoonText =
                        `${stringHelper.pluralize(availableUnitSoonCount, 'unit', 'units')} available soon`;
                    availableUnitArrayText.push(availableUnitSoonText);
                }
                if (availableUnitArrayText.length > 0) {
                    availableText = availableUnitArrayText.join(', ');
                }
            } else if (floorplan.active) {
                availableText = 'Floor plan available';
            }
        }
        const isFloorplanAvailable = availableText !== UNAVAILABLE_FLOORPLAN_TEXT;
        const bedOptions = ['', 'studio', '1', '2', '3', '4', '5', '6', '7', '8'];
        const bathOptions = ['', '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5',
            '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10+'];
        if (floorplan.beds !== '') {
            bedOptions.shift();
        }
        if (floorplan.baths !== '') {
            bathOptions.shift();
        }

        const isDisabled = formData.vaultware || isInputFormDisabled;

        return (
            <div
                className="FloorplansMF-floorplan"
                key={`floorplan${index}`}
            >
                <StyledFloorplansBarSpacer
                    marginBottom="xs"
                    borderBottom={showFloorplanDetails}
                    onClick={() => this.toggleFloorplan(index)}
                >
                    <CustomTag>
                        <Text>
                            {this.generateFloorplanTitle(floorplan)}
                            {showErrorText && (
                                <StyledFormHelp
                                    marginLeft="xs"
                                    error={true}
                                >
                                        Please expand to fix errors
                                </StyledFormHelp>
                            )}
                            {availableText && (
                                <Text
                                    marginLeft="xs"
                                    fontColor={isFloorplanAvailable ? 'green500' : 'gray500'}
                                >
                                    {availableText}
                                </Text>
                            )}
                        </Text>

                        <StyledDropdownSpacer
                            paddingBottom={0}
                            paddingLeft={0.5}
                        >
                            {showFloorplanDetails ? <IconChevronUp size="xs" /> : <IconChevronDown size="xs" />}
                        </StyledDropdownSpacer>
                    </CustomTag>
                </StyledFloorplansBarSpacer>

                {showFloorplanDetails && (
                    <React.Fragment>
                        <Row paddingY="xs">
                            <Col
                                xs={6}
                                md={3}
                            >
                                <FormField marginBottom="sm">
                                    <StyledLabel disabled={isDisabled} required={true}>Floor plan name</StyledLabel>
                                    <Input
                                        aria-label="Floor plan name"
                                        name="name"
                                        placeholder="Floor plan name"
                                        disabled={isDisabled}
                                        error={!!floorPlanErrors.name}
                                        value={floorplan.name}
                                        onChange={e => this.updateFloorplan('name', e.target.value, index)}
                                        onBlur={e => saveFloorplanData('name', e.target.value, index)}
                                        onFocus={() => this.props.updateOnFocus('name', floorplan.name)}
                                        data-test="floorplan-detail-name"
                                    />
                                    {floorPlanErrors.name && (
                                        <FormHelp
                                            error={!!floorPlanErrors.name}
                                            dangerouslySetInnerHTML={{ __html: floorPlanErrors.name }}
                                        />
                                    )}
                                </FormField>
                            </Col>
                            <Col
                                xs={6}
                                md={3}
                                mediaQuery={{ lg: { paddingRight: 'sm' } }}
                            >
                                <FormField marginBottom="sm">
                                    <StyledLabel
                                        disabled={isDisabled}
                                        required={true}
                                    >
                                        Beds
                                    </StyledLabel>
                                    <Select
                                        aria-label="Beds"
                                        disabled={isDisabled}
                                        error={floorPlanErrors.beds}
                                        name="beds"
                                        placeholder="Beds"
                                        type="text"
                                        value={floorplan.beds}
                                        onChange={e => this.updateFloorplan('beds', e.target.value, index)}
                                        onBlur={(e) => {
                                            e.stopPropagation();
                                            saveFloorplanData('beds', e.target.value, index);
                                        }}
                                        onFocus={() => this.props.updateOnFocus('beds', floorplan.beds)}
                                        data-test="floorplan-detail-beds"
                                    >
                                        {bedOptions.map(((option) => {
                                            if (option === 'studio') {
                                                return <option key={option} value={0}>{option}</option>;
                                            }
                                            return <option key={option} value={option}>{option}</option>;
                                        }))}
                                    </Select>
                                    {floorPlanErrors.beds && (
                                        <FormHelp error={true}>{floorPlanErrors.beds}</FormHelp>)}
                                </FormField>
                            </Col>
                            <Col
                                xs={6}
                                md={3}
                                mediaQuery={{ lg: { paddingLeft: 'sm' } }}
                            >
                                <FormField marginBottom="sm">
                                    <StyledLabel
                                        disabled={isDisabled}
                                        required={true}
                                    >
                                        Baths
                                    </StyledLabel>
                                    <Select
                                        aria-label="Baths"
                                        disabled={isDisabled}
                                        error={floorPlanErrors.baths}
                                        name="baths"
                                        placeholder="Baths"
                                        type="number"
                                        value={floorplan.baths}
                                        onChange={e => this.updateFloorplan('baths', e.target.value, index)}
                                        onBlur={(e) => {
                                            e.stopPropagation();
                                            saveFloorplanData('baths', e.target.value, index);
                                        }}
                                        onFocus={() => this.props.updateOnFocus('baths', floorplan.baths)}
                                        required // eslint-disable-line react/jsx-boolean-value
                                        data-test="floorplan-detail-baths"
                                        isRequired={true}
                                    >
                                        {bathOptions.map(((option) => {
                                            if (option === '10+') {
                                                return <option key={option} value={10}>{option}</option>;
                                            }
                                            return <option key={option} value={option}>{option}</option>;
                                        }))}
                                    </Select>
                                    {floorPlanErrors.baths && (
                                        <FormHelp error={true}>{floorPlanErrors.baths}</FormHelp>)}
                                </FormField>
                            </Col>
                            <Col
                                xs={6}
                                md={3}
                                mediaQuery={{ lg: { paddingRight: 'sm' } }}
                            >
                                <FormField>
                                    <StyledLabel disabled={isDisabled}>Sq ft</StyledLabel>
                                    <Input
                                        aria-label="Square feet"
                                        error={floorPlanErrors.sqft}
                                        disabled={isDisabled}
                                        name="sqft"
                                        type="number"
                                        value={floorplan.sqft}
                                        onChange={e => this.updateFloorplan('sqft', e.target.value, index)}
                                        onBlur={e => this.updateSqFt(e.target.value, index)}
                                        onFocus={() => this.props.updateOnFocus('sqft', floorplan.sqft)}
                                        data-test="floorplan-detail-sqft"
                                    />
                                    {floorPlanErrors.sqft && (
                                        <FormHelp error={true}>
                                            {floorPlanErrors.sqft}
                                        </FormHelp>
                                    )}
                                </FormField>
                            </Col>
                        </Row>
                        <Row paddingY="xs">
                            <Col
                                xs={6}
                                md={3}
                                mediaQuery={{ lg: { paddingLeft: 'sm' } }}
                            >
                                <FormField>
                                    <StyledLabel disabled={isDisabled || hasUnits}>Min price</StyledLabel>
                                    <AdornedInput
                                        inputId="AdornedInput-MinPrice"
                                        input={(
                                            <Input
                                                aria-label="Min price"
                                                name="lowPrice"
                                                value={floorplan.lowPrice}
                                                onChange={e => this.updatePrice('lowPrice', e.target.value, index)}
                                                onBlur={e => this.savePrice('lowPrice', e.target.value, index)}
                                                onFocus={() => this.handlePriceFocus('lowPrice', floorplan.lowPrice)}
                                                data-test="floorplan-detail-low-price"
                                            />
                                        )}
                                        disabled={isDisabled || hasUnits}
                                        error={floorPlanErrors.lowPrice}
                                        leftAdornment={floorplan.lowPrice && <Adornment>$</Adornment>}
                                        rightAdornment={<Adornment>/mo</Adornment>}
                                    />
                                    <FormHelp>Note: Floor plans without prices will not appear on Zillow.</FormHelp>
                                    {floorPlanErrors.lowPrice && (
                                        <FormHelp error={true}>
                                            {floorPlanErrors.lowPrice}
                                        </FormHelp>
                                    )}
                                </FormField>
                            </Col>
                            <Col
                                xs={6}
                                md={3}
                                mediaQuery={{ lg: { paddingRight: 'sm' } }}
                            >
                                <FormField>
                                    <StyledLabel disabled={isDisabled || hasUnits}>Max price</StyledLabel>
                                    <AdornedInput
                                        inputId="AdornedInput-MaxPrice"
                                        input={(
                                            <Input
                                                aria-label="Max price"
                                                name="highPrice"
                                                value={floorplan.highPrice}
                                                onChange={e => this.updatePrice('highPrice', e.target.value, index)}
                                                onBlur={e => this.savePrice('highPrice', e.target.value, index)}
                                                onFocus={() => this.handlePriceFocus('highPrice', floorplan.highPrice)}
                                                data-test="floorplan-detail-high-price"
                                            />
                                        )}
                                        disabled={isDisabled || hasUnits}
                                        error={floorPlanErrors.highPrice}
                                        leftAdornment={floorplan.highPrice && <Adornment>$</Adornment>}
                                        rightAdornment={<Adornment>/mo</Adornment>}
                                    />
                                    {floorPlanErrors.highPrice && (
                                        <FormHelp error={true}>
                                            {floorPlanErrors.highPrice}
                                        </FormHelp>
                                    )}
                                </FormField>
                            </Col>
                            {floorplan.units.length === 0 && (
                                <Col
                                    xs={6}
                                    md={3}
                                    mediaQuery={{ lg: { paddingLeft: 'sm' } }}
                                >
                                    <FormField>
                                        <Label>
                                        Show as available
                                        </Label>
                                        <Switch
                                            size="lg"
                                            controlId={`Switch-available${index}`}
                                            checkbox={(
                                                <Checkbox
                                                    checked={floorplan.active}
                                                    onClick={() => this.updateActive(!floorplan.active, index)}
                                                />
                                            )}
                                            disabled={isDisabled}
                                        />
                                        {floorPlanErrors.active &&
                                        <FormHelp error={true}>{floorPlanErrors.active}</FormHelp>
                                        }
                                    </FormField>
                                </Col>
                            )}
                            <StyledDeleteCol
                                xs={6}
                                md={3}
                                mediaQuery={{ lg: { paddingRight: 'sm' } }}
                            >
                                {(floorPlanCount > 1 && !isDisabled) && (
                                    <TextButton onClick={e => this.removeFloorplan(e, index)}>
                                        Delete floor plan
                                    </TextButton>
                                )}
                            </StyledDeleteCol>
                        </Row>
                        <Row paddingY="xs">
                            <StyledMediaCol>
                                <div>
                                    <StyledLabelTitle>Floor plan Tour</StyledLabelTitle>
                                    <TourCardEditable
                                        floorPlanIndex={index}
                                        tour={floorplan.tour}
                                        tourType="floorPlan"
                                        hasBigBottomBorder={true}
                                        isHidden={hasUnits}
                                        isDisabled={canEditTourOverwrite ? false : isDisabled}
                                        size="md"
                                        onChange={this.props.onChangeTour}
                                        showPublish={!hasUnits}
                                        updateStatusMessage={this.props.updateStatusMessage}
                                        updateFormData={this.props.updateFormData}
                                        formData={this.props.formData}
                                    />
                                </div>
                                <StyledLayoutContainerSpacer
                                    paddingY="sm"
                                    paddingX={0}
                                    mediaQuery={{ lg: { paddingY: 0, paddingRight: 0, paddingLeft: 'sm' } }}
                                >
                                    {this.renderLayout(floorplan, index)}
                                </StyledLayoutContainerSpacer>
                            </StyledMediaCol>
                        </Row>
                        <UnitsMF
                            canAddUnits={canAddUnits}
                            canEditTourOverwrite={canEditTourOverwrite}
                            floorPlanIndex={index}
                            floorplans={this.props.formData.floorplans}
                            formData={formData}
                            isDisabled={formData.vaultware || isInputFormDisabled}
                            isMobile={isMobile}
                            onRemoveUnit={this.handleRemoveUnit}
                            onToggleActive={this.updateActive}
                            units={floorplan.units}
                            updateFormData={this.props.updateFormData}
                            updateStatusMessage={this.props.updateStatusMessage}
                            updateParentFloorplanPrice={this.props.updateParentFloorplanPrice}
                            validateFloorplan={this.props.validateFloorplan}
                        />
                        {isPostingPathAdmin && (
                            <div>
                                <StyledHR marginY="lg" />

                                <Row paddingY="xs">
                                    <Col>{this.renderFloorplanPhotos(index)}</Col>
                                </Row>

                                <Row paddingY="xs">
                                    <Col>
                                        <AmenitiesTags
                                            label="Floor Plan Amenities (admin only)"
                                            disabled={formData.vaultware}
                                            addTag={userAmenity => this.addAmenity(index, userAmenity)}
                                            removeTag={
                                                (amenityIndex, amenityId) => this.removeFloorplanAmenity(
                                                    index,
                                                    amenityIndex,
                                                    amenityId
                                                )
                                            }
                                            placeholder="List other amenities available"
                                            showSelectUnits={true}
                                            selectUnits={this.state.amenityInSelectUnits}
                                            tagsArray={this.showAmenities(index)}
                                            updateSelectUnits={this.updateSelectUnits}
                                            updateErrorObj={updateErrorObj}
                                            updateStatusMessage={updateStatusMessage}
                                            clearAmenitiesErrorObj={this.clearAmenitiesErrorObj}
                                            floorPlanIndex={index}
                                        />
                                        {errorObj.floorplans[index].amenities && (
                                            <FormHelp
                                                error={errorObj.floorplans[index].amenities}
                                                dangerouslySetInnerHTML={
                                                    { __html: errorObj.floorplans[index].amenities }
                                                }
                                            />
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        )}

                        <StyledHR marginY="lg" />
                    </React.Fragment>
                )}
            </div>
        );
    }

    render() {
        const {
            addFloorplan,
            allFloorplansExpanded,
            props,
            renderFloorplan,
            toggleAllFloorplans,
        } = this;

        const { isInputFormDisabled } = props;
        const { formData } = { ...this.state };

        const floorplansExpanded = allFloorplansExpanded();
        const toggleFloorplansDetailsText = floorplansExpanded ?
            'Collapse all floor plans' : 'Expand all floor plans';

        return (
            <div className="FloorplansMF">
                <Row paddingY="xs">
                    <Col sm={6}>
                        <Text
                            marginBottom="xs"
                            mediaQuery={{ lg: { marginBottom: 'sm' } }}
                            fontType="h4"
                            as="div"
                        >
                            Manage floor plans
                        </Text>
                    </Col>

                    <Col xs={6} align="flex-end">
                        <StyledToggleViewLink
                            onClick={() => toggleAllFloorplans(!floorplansExpanded)}
                        >
                            {toggleFloorplansDetailsText}
                        </StyledToggleViewLink>
                    </Col>
                </Row>

                <StyledAnchor id="floorplans" />

                {formData.vaultware && (
                    <Row paddingY="xs">
                        <Center>
                            <Text
                                fontColor="red600"
                                fontType="body"
                                as="div"
                            >
                                These floor plans are controlled by a pricing feed from Vaultware.
                                <br />
                                Vaultware ID:
                                { formData.vaultwarePropertyId }
                            </Text>
                        </Center>
                    </Row>
                )}

                {formData.floorplans.map((floorplan, index) => renderFloorplan(floorplan, index))}

                <Row paddingY="xs">
                    <Col align="flex-start">
                        <Button
                            buttonType="primary"
                            onClick={addFloorplan}
                            disabled={isInputFormDisabled}
                            data-test="add-floorplan"
                        >
                            + Add Floor Plan
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
});

export default connect(mapStateToProps)(FloorplansMF);
